import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { SharedService } from 'src/app/shared/shared.service';
import { OktaService } from '../../shared/services/oktaservice/okta.service';
import { UserInfoService } from 'src/app/shared/services/user-info/user-info-service';


interface Claim {
  claim: string;
  value: string;
}

@Component({
  selector: 'app-banner-layout',
  templateUrl: './banner-layout.component.html',
  styleUrls: ['./banner-layout.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerLayoutComponent  {

  user$ = this.authService.getUser();
  claims: Array<Claim>;
  userClaim: any;
  showUser: any = false;

  constructor(private authService: OktaAuthService,
              private userInfoService: UserInfoService) { }

  async showUserInfo() {
    const user = await this.authService.getUser();
    this.claims = Object.entries(user).map(entry => ({ claim: entry[0], value: entry[1] }));
    if (user) {
      this.showUser = true;
      this.userClaim = user;
    }
  }

  logOutAndRemember() {
    this.userInfoService.logOut().subscribe();
    this.authService.logout('/login');
  }
}
